import React from 'react'
import { BaseErrorDisplay } from './BaseErrorDisplay'
import infoSvg from '../icons/blankslate-info-icon.svg'

export const FederatedUserInvitationInvalidToken = () => (
  <BaseErrorDisplay
    title="There is a problem processing your invitation"
    subtitle="FEDERATED USER INVITATION INVALID TOKEN"
    description="Invalid federated user invitation token. Please contact your support."
    imgSrc={infoSvg}
  />
)
